import { APP_DEFAULT_PATH } from 'config';
// material-ui
import { ButtonBase } from '@mui/material';
import BuzLogo from './BuzLogo';
import { Link } from 'react-router-dom';
// project-imports
// import Logo from './LogoMain';
// import LogoIcon from './LogoIcon';
import PropTypes from 'prop-types';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = ({ isIcon, sx, to }) => (
  <ButtonBase disableRipple component={Link} to={!to ? APP_DEFAULT_PATH : to} sx={sx}>
    {isIcon ? <BuzLogo /> : <BuzLogo />}
  </ButtonBase>
);

LogoSection.propTypes = {
  reverse: PropTypes.bool,
  isIcon: PropTypes.bool,
  sx: PropTypes.object,
  to: PropTypes.string
};

export default LogoSection;
